// https://developer.sgmarkets.com/docs/design-system/v5/foundations/layout.html

// Size

export const SIZES = ['sm', 'md', 'lg', 'xl'] as const;

export type Size = (typeof SIZES)[number];

export const FULL_SIZES = [...SIZES, 'xxl'];

export type FullSize = (typeof FULL_SIZES)[number];

// Sizing

export const SIZING = ['auto', '25%', '50%', '75%', '100%'];

export type Sizing = (typeof SIZING)[number];

// Spacing

export const SPACINGS = ['0px', '4px', '8px', '12px', '16px', '24px', '32px', '48px', '64px', '96px', '128px'] as const;

export type Spacing = (typeof SPACINGS)[number];

export const FORM_CONTROL_SPACING: Record<Size, number> = {
  sm: 4,
  md: 10,
  lg: 12,
  xl: 16,
};

export const SVG_ICON_SIZE: Record<Size, number> = {
  sm: 16,
  md: 20,
  lg: 22,
  xl: 24,
};

export const SPINNER_OVERRIDE_SIZE: Record<Size, number> = {
  sm: 16,
  md: 18,
  lg: 22,
  xl: 24,
};

// Visual style purpose for the picker

export type Purpose = 'default' | 'outline';
